import { useEffect, useRef, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { CommonApiData } from '../CommonComponents/EnvConfig';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from '../CommonComponents/ExportData';
import { FormButton, ImportButton, InputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const DealerTypeMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [formData, setFormData] = useState({
        dealerTypeID: '',
        dealerTypeCode: 'System Generated',
        dealerTypeName: '',
        isActive: true
    });

    const getDealerTypeMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowDealerTypeMaster`, data)
        setIsLoading(false)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        else if (res.Status === "ERROR") {
            setTableData([])
        }
        else if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = async () => {
        setFormData({
            dealerTypeID: '',
            dealerTypeCode: 'System Generated',
            dealerTypeName: '',
            isActive: true

        });
        await setImportData([])
        await BulkClearData(setName)
        await setName('')
        await setStatus([])
        filterData.SearchText = '';
        getDealerTypeMasterData();
    }
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getDealerTypeMasterData(value);
    };
    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateDealerTypeMaster`, formData)
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditDealerTypeMaster`, { dealerTypeID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteDealerTypeMaster`, { dealerTypeID: id }, getDealerTypeMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }
    const DownloadFormat = async () => {
        await DownloadFileAtURL('DealerTypeMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'DealerTypeMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };

    const handleBulk = async () => {
        const Data2 = {
            "authToken": CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": CommonApiData().UserCode,
            "companyCode": CommonApiData().CompanyCode,
            dealerTypeCode: 'System Generated',

        };
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("dealerTypeName", "isActive")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateDealerTypeMaster', ImportData, Data2, getDealerTypeMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }
    useEffect(() => {
        getDealerTypeMasterData()
        document.title = 'Dealer Type Master'
        inputrefs.current['txtDealerTypeName'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Dealer Type Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-6 col-lg-8'>
                            <div className='row'>
                                <InputBox
                                    id="txtDealerTypeCode"
                                    type="text"
                                    label='Dealer Type Code'
                                    divclassname="col-lg-4 col-md-6 col-sm-12 mb-1"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtDealerTypeName'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    required={true}
                                    placeholder='System Generated'
                                    name='DealerTypeCode'
                                    value={formData.dealerTypeCode}
                                    disabled
                                />
                                <InputBox
                                    id="txtDealerTypeName"
                                    type="text"
                                    label='Dealer Type Name'
                                    divclassname="col-lg-4 col-md-6 col-sm-12 mb-1"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        }
                                    }}
                                    required={true}
                                    onChange={(e) => setFormData({ ...formData, dealerTypeName: e.target.value })}
                                    inputrefs={inputrefs}
                                    placeholder='Dealer Type Name'
                                    value={formData.dealerTypeName}
                                />
                                <Switch
                                    id="txtActive"
                                    label='Active'
                                    inputrefs={inputrefs}
                                    checked={formData.isActive}
                                    divclassname="col-lg-2 col-md-2 me-4"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                                />

                            </div>
                        </div>
                        <div className='d-flex col-md-6 col-lg-4 h-65 mb-2'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PayMode, Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                        <div className='card-body'>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                handleExport={() => handleDownloadExcel(`/api/Master/ShowDealerTypeMaster`, filterData, 'Dealer Type Master')}
                                handleClear={handleClear}
                            />
                        </div>
                    </div>

                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'DealerTypeMaster'}
                handleFilter={() => {
                    getDealerTypeMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />

        </>
    )
}
export default DealerTypeMaster;